export interface BarcodeScannerState {
  scannedCode?: String;
}

export const SET_SCANNED_CODE = 'SET_SCANNED_CODE';

export type SetScannedCodeAction = {
  type: typeof SET_SCANNED_CODE;
  payload: {
    scannedCode: String;
  };
};

export type BarcodeScannerActionTypes = SetScannedCodeAction;
